import { IPerfilFinanceiro } from "../../../Interfaces/Geral/GestaoDeCadastro/PerfilFinanceiro/PerfilFinanceiroInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarPerfilFinanceiroService() {
    return Service(
        Axios.get<Array<IPerfilFinanceiro>>(
            `/home/perfilfinanceiroconta/listarperfilfinanceirocontas`
        )
    );
}

export async function GetPerfilFinanceiroService(
    idPerfilFinanceiroConta: number
) {
    return Service(
        Axios.get<IPerfilFinanceiro>(
            `/home/perfilfinanceiroconta/getperfilfinanceiroconta?idPerfilFinanceiroConta=${idPerfilFinanceiroConta}`
        )
    );
}

export async function CadastrarPerfilFinanceiroService(
    data: IPerfilFinanceiro
) {
    return Service(
        Axios.post(
            `/home/perfilfinanceiroconta/cadastrarperfilfinanceiroconta`,
            data
        )
    );
}

export async function AtualizarPerfilFinanceiroService(
    data: IPerfilFinanceiro
) {
    return Service(
        Axios.put(
            `/home/perfilfinanceiroconta/atualizarperfilfinanceiroconta`,
            data
        )
    );
}

export async function DeletarPerfilFinanceiroService(
    idPerfilFinanceiroConta: number
) {
    return Service(
        Axios.delete(
            `/home/perfilfinanceiroconta/removerperfilfinanceiroconta?idPerfilFinanceiroConta=${idPerfilFinanceiroConta}`
        )
    );
}
